export const adminReportTranslationsRo = {
  'admin.report.raw_data.title': 'Date brute',
  'admin.report.vizualization.title': 'Vizualizare',
  'admin.report.path.report_not_found': 'Raportul nu a fost găsit',
  'admin.report.modal.title': 'Raport',
  'admin.report.status.success': 'Succes',
  'admin.report.status.sent': 'Trimis',
  'admin.report.status.confirmed': 'Confirmat',
  'admin.report.status.sending': 'Trimitere în curs',
  'admin.report.status.failed': 'Eșec',
  'admin.report.status.error': 'Eroare',
  'admin.report.status.pending': 'În așteptare',
  'admin.report.status.processing': 'În curs de procesare',
  'admin.report.status.cancelled': 'Anulat',
  'admin.report.status.unknown': 'Necunoscut',
  'admin.report.back_to_list': 'Înapoi la listă',
  'admin.report.title': 'Raport',
  'admin.report.notifications.status': 'Stare',
  'admin.report.notifications.notification_channel': 'Canal de notificare',
  'admin.report.notifications.created_at': 'Data creării',
  'admin.report.notifications.updated_at': 'Data actualizării',
  'admin.report.notifications.sended_at': 'Data trimiterii',
  'admin.report.notifications.title': 'Notificări',
  'admin.report.notifications.user': 'Utilizator',
  'admin.report.notifications.recipient': 'Destinatar',
  'admin.report.producer.table.title': 'Raport pe exploatație',
  'admin.report.producer.producer_ref_column.title': 'Exploatație',
  'admin.report.producer.organization_ref_column.title': 'Organizație',
  'admin.report.producer.report_job_number_column.title': 'Nr. rapoarte',
  'report.query-selector.end-date': 'Data de sfârșit',
  'report.query-selector.start-date': 'Data de început',
  'admin.report.producer.select-all.label': 'Selectează tot',
};
